import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const CloudAppSection = styled('div')<{ theme?: TTheme }>`
    padding: 20px;
    margin-top: 24px;
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.colors.greys[200]};

    .cloud-app-integrations-title {
        margin-bottom: 24px;
    }
`
